// API Configuration
// Environment-specific configuration using Vite environment variables

// Get the API URL from environment variables
// In development: uses Vite proxy to forward /api requests
// In production: can be configured to use absolute URLs
// Leave VITE_API_URL empty when the backend serves this frontend itself: requests
// then go to the same host the page was loaded from (relative /api).
const API_URL = (import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
const APP_ENV = import.meta.env.VITE_APP_ENV || 'development';

// For local development, use proxy path
// For other environments, use the full API URL
export const API_BASE_URL = APP_ENV === 'development' || !API_URL ? '/api' : API_URL + '/api';

// Export configuration object
const config = {
    apiUrl: API_BASE_URL,
    apiBaseUrl: API_URL,
    environment: APP_ENV,
    isDevelopment: APP_ENV === 'development',
    isProduction: APP_ENV === 'production',
    isUAT: APP_ENV === 'uat'
};

export default config;